import React, { useState } from "react";
import Logo from "../assets/logo1.png";
import { BarChart, FavoriteBorderOutlined } from "@mui/icons-material";
const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  return (
    <>
      <div className="top_favorite_heading">
        <div className="top_favorite_heading_icon">
          <FavoriteBorderOutlined />
        </div>
        <div className="top_favorite_heading_text">
          Share QR Cards! Your all-in-one tool!
        </div>
      </div>
      <div className="header_body">
        <div className="header_body_left">
          <img src={Logo} alt="" />
        </div>
        <div className={`header_body_right`}>
          <nav>
            <ul className="nav_style">
              <li
                className="drawer-item"
                onClick={() => {
                  window.location = "https://synkoria.com/about/";
                }}
              >
                About
              </li>
              <li
                className="drawer-item"
                onClick={() => {
                  window.location = "https://synkoria.com/about/";
                }}
              >
                Add On
              </li>
              <li
                className="drawer-item"
                onClick={() => {
                  window.location = "https://synkoria.com/contact-us/";
                }}
              >
                Contact Us
              </li>
            </ul>
          </nav>
          <button
            className="style_nav_button"
            type="button"
            onClick={() => {
              window.location = "https://synkoria.com/sign-in/";
            }}
          >
            <BarChart /> SIGN IN
          </button>
        </div>
        <div className={`menu-icon`} onClick={toggleDrawer}>
          &#9776; {/* Menu icon */}
        </div>
        <div className={`drawer ${isDrawerOpen ? "open" : ""}`}>
          <div className="close-icon" onClick={toggleDrawer}>
            &#10005; {/* Close icon */}
          </div>
          <a href="https://synkoria.com/about/" className="drawer-item">
            About
          </a>
          <a href="https://synkoria.com/about/" className="drawer-item">
            Add On
          </a>
          <a href="https://synkoria.com/contact-us/" className="drawer-item">
            Contact Us
          </a>
        </div>
      </div>
      <div
        style={{
          height: "2px",
          backgroundColor: "#EDEDED",
          width: "100vw",
        }}
      ></div>
    </>
  );
};

export default Header;
